<template>
  <div>
    <el-select :value="status" value-key="key" :size="size" :placeholder="$t('card.status')" @input="change($event)" :clearable="true">
      <el-option label="----------" value="" />
      <el-option label="未激活" value="0" />
      <el-option label="已激活" value="1" />
      <el-option label="已停用" value="2" />
<!--      <el-option label="已限速" value="3" />-->
    </el-select>
  </div>
</template>

<script>
export default {
  data () {
    return {
      status: 0
    }
  },
  props: ['value', 'size', 'showAllTip', 'showAllTipLabel'],
  methods: {
    change: function (val) {
      this.status = val
      this.$emit('input', this.status)
    }
  },
  mounted () {
    this.status = this.value
  },
  watch: {
    value: function (val, oldVal) {
      this.status = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/card/components/StatusSelect.vue